import {Component, OnInit} from "@angular/core";
import {User} from "../../_models";
import {UserService} from "../../_services";

@Component({
    standalone: false,
  selector: "my-profile-component",
  templateUrl: 'my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})

export class MyProfileComponent implements OnInit {
  user: User | {};
  constructor(public userSerice: UserService) {
  }
  ngOnInit() {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.userSerice.getById(currentUser.userId).subscribe(u => this.user = u);
  }
}
